const config = {
  Panel_interview: '小组面试',
  number_team: '小组人数：',
  interview_location: '面试地点：',
  interview_time: '面试时间：',
  interview_date: '面试日期：',
  Rated_items: '评分项目',
  done: '已完成：',
  details: '学生详细资料',
  Sname: '学生姓名：',
  application_id: '申请编号：',
  sex: '性別：',
  man: '男',
  girl: '女',
  Birthdate: '出生日期：',
  Parent_material: '家长资料',
  name: '名称：',
  career: '职业：',
  telephone: '联络电话：',
  Native_graduate: '本国毕业生：',
  FATHER: '父亲',
  MOTHER: '母亲',
  GUARDIAN: '监护人',
  Yes: '是',
  no: '否',
  Writing_evaluation: '文字评价',
  stockpile: '储存',
  candidate: '输入对面试者的评价',
  interview_system: '面试系统',
  interview_panel: '面试小组',
  attendees: '只显示出席者',
  score: '分数',
  select: '您还没选择评分项目',
  grade: '分数',
  // 假數據內容
  item_one: '请小朋友把积木叠起来。',
  item_two: '请小朋友把珠子连串起来。',
  item_three: '给小朋友拼图，看看他們是否懂得如何拼组。',
  item_four:
    '讓小朋友自选图书或玩具﹐观察在玩耍过程中﹐是否自主性强﹑主动积极。',
  item_five:
    '在小组活动中﹐观察是否能与其他人融洽相处﹐是否合群有礼﹐是否表現霸道或者害羞。',
  total: '人数：',
  ApplicationNo: '申请编号',
  InterviewScores: '评分',
  employee: '{{value}}是PLK员工吗?',
  graduate: '{{value}}是PLK毕业生吗?',
  WorkPlace: '工作场所',
  FirstLanguage: '第一语言',
  Telephonenight: '电话机(夜间)',
  SingleMode: '单人模式',
  select_task: '选择题目',
  date: '日期',
  teacher: '老师',
  no_data: '没有相关资料',
  total_score: '总分',
  go_back_list: '返回列表',
  NameEnglish: '英文名称：',
  Parent: '家长',
  tit: '提示',
  determine: '确认',
  cancel: '取消',
  resetscore: '您确定要重置分数吗？',
  Resetsucceeded: '重置成功',
  Resetfailed: '重置失败',
  InterviewNo: '面试编号：',
  studying: '是否有兄姐在本校就读?：',
  ChangeRole: '所有角色',
  _ChangeRole: '更改角色',
  no_record: '没有记录'
};

export default config;
